define([
    'componentsCore',
    'vKShareButton/component/vKShareButton',
    'vKShareButton/aspect/vkPostMessageAspect',
    'skins',
    'vKShareButton/skins/skins.json'
], function (componentsCore, vKShareButton, vkPostMessageAspect, skinsPackage, skinsJson) {
    'use strict';

    componentsCore.siteAspectsRegistry.registerSiteAspect(vkPostMessageAspect.name, vkPostMessageAspect.ctor);


    componentsCore.compRegistrar.register('wysiwyg.viewer.components.VKShareButton', vKShareButton);
    skinsPackage.skinsMap.addBatch(skinsJson);

    return vKShareButton;
});
